import classNames from 'classnames';
import React, { memo } from 'react';
import css from './Divider.module.scss';

interface ComponentProps {
    /**
     * Determines style of divider. Default 'themed'
     *
     * themed - Thicker divider using theme color
     * thin - Thinner divider using gray color
     */
    variant?: 'themed' | 'thin' | 'plain';
    /**
     * Orientation of divider.
     */
    orientation: 'horizontal' | 'vertical';
}

/**
 * Displays a horizontal dividing line of the theme's primary color
 */
export const GMDivider: React.FC<ComponentProps> = memo(({ variant = 'themed', orientation }) => {
    return (
        <div className={classNames({
            [css.horizontal]: orientation === 'horizontal',
            [css.vertical]: orientation === 'vertical',
            [css.thin]: variant === 'thin',
            [css.themed]: variant === 'themed',
            [css.plain]: variant === 'plain',
        })}
        />
    );
});